import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWelcomePageOtpGate = loadable(() => import(/* webpackChunkName: "content/guest/welcome-otp-gate" */ './WelcomePageOtpGate'), 'WelcomePageOtpGate');
